<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="检查签名" prop="checkSign">
          <el-input v-model="dataForm.checkSign" placeholder="检查签名"></el-input>
      </el-form-item>
          <el-form-item label="密码" prop="password">
          <el-input v-model="dataForm.password" placeholder="密码"></el-input>
      </el-form-item>
          <el-form-item label="随机key" prop="randomKey">
          <el-input v-model="dataForm.randomKey" placeholder="随机key"></el-input>
      </el-form-item>
          <el-form-item label="响应url" prop="responseUrl">
          <el-input v-model="dataForm.responseUrl" placeholder="响应url"></el-input>
      </el-form-item>
          <el-form-item label="响应内容" prop="responseBody">
          <el-input v-model="dataForm.responseBody" placeholder="响应内容"></el-input>
      </el-form-item>
          </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        checkSign: '',
        password: '',
        randomKey: '',
        responseUrl: '',
        responseBody: '',
        createDate: '',
        creator: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        checkSign: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        password: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        randomKey: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        responseUrl: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        responseBody: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/lianlianpasswordparsing/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/lianlianpasswordparsing/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
